export default __webpack_public_path__ + "static/media/observer-api-for-modern-javascript.09f9041d.jpg";